import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { CentralisedBanner } from "./Banner";
import { CentralizedBannerTags } from "./CentralizedBannerTags/CentralizedBannerTags";
import { CentralizedBannerType } from "./CentralizedBannerType/CentralizedBannerType";

export const CentralizedBannerTab = () => {
  const query = useQuery();
  const navigate = useNavigate();
  useEffect(() => {
    if (query.get("id")) {
      return;
    }

    const activeTab = query.get("activeTab");
    if (!activeTab) {
      navigate(`/centralized/centralizedBanner?activeTab=centralizedBanner`, {
        replace: true,
      });
    }
  }, [query.get("activeTab")]);
  const travellersInfoCard = [
    {
      label: "Banners List",
      key: "centralizedBanner",
      children: <CentralisedBanner />,
    },
    // {
    //   label: "Tags",
    //   key: "centralizedBannerTags",
    //   children: <CentralizedBannerTags />,
    // },
    // {
    //   label: "Type",
    //   key: "centralizedBannerType",
    //   children: <CentralizedBannerType />,
    // },
  ];

  const handleProductManagement = (activeTab: any) => {
    if (activeTab === "centralizedBanner") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedBanner/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Banner
        </Button>
      );
    } else if (activeTab === "centralizedBannerTags") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedBannerTags/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Tag
        </Button>
      );
    } else if (activeTab === "centralizedBannerType") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedBannerType/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Type
        </Button>
      );
    }
  };

  return (
    <ContentWrapper
      title={"Banners"}
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleProductManagement(query.get("activeTab"))}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={travellersInfoCard}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
